<template>
  <div>
    <button type="button" class="icon-btn" title="Edit slider" @click="showmodal">
      <feather type="edit-2" size="16"></feather>
    </button>
    <b-modal size="xl" :id="'Modal' + id" title="Slider Edit" @ok="onSave" ok-title="Save" ok-variant="primary"
      @show="OnShowModal" @hidden="clear" no-close-on-esc no-close-on-backdrop>
      <div class="card">
        <div class="card-body">
          <div class="digital-add needs-validation">
            <div class="form-group">
              <label class="col-form-label pt-0">Upload <span>*</span></label>
              <vue-dropzone id="EditSlider" :options="EditSliderOptions" class="dropzone digits" ref="EditSlider"
                :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-removed-file="fileRemoved"
                @vdropzone-complete="uploadComplete"
                @vdropzone-sending="sending" @vdropzone-error="uploadError">
              </vue-dropzone>
            </div>
            <div class="row product-adding">
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="validationtitle" class="col-form-label pt-0">Title</label>
                  <!-- Cadre couleur à droite du champ : ouvre la palette -->
                  <div class="slider-color-input">
                    <input class="form-control" id="validationtitle" type="text" v-model="Vtitle" />
                    <input type="color" v-model="Vtitlecolor" title="Title color" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="validationssubtitle" class="col-form-label pt-0">Sub Title</label>
                  <div class="slider-color-input">
                    <input class="form-control" id="validationssubtitle" type="text" v-model="Vsubtitle" />
                    <input type="color" v-model="Vsubtitlecolor" title="Sub title color" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="validationoffer" class="col-form-label pt-0">offer</label>
                  <div class="slider-color-input">
                    <input class="form-control" id="validationoffer" type="text" v-model="Voffer" />
                    <input type="color" v-model="Voffercolor" title="Offer color" />
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="validationlink" class="col-form-label pt-0">Link</label>
                  <input class="form-control" id="validationlink" type="text" v-model="Vlink" />
                </div>
                <div class="form-group">
                  <label class="col-form-label">Align</label>
                  <select class="custom-select" v-model="Valign">
                    <option value="p-left">Left</option>
                    <option value="p-center">Center</option>
                    <option value="p-right">Right</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Status</label>
                  <div class="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                    <label class="d-block" for="edo-ani">
                      <input class="radio_animated" id="edo-ani" type="radio" name="rdo-ani" v-model="Vstatus"
                        :value="true" />
                      Enable
                    </label>
                    <label class="d-block" for="edo-ani1">
                      <input class="radio_animated" id="edo-ani1" type="radio" name="rdo-ani" v-model="Vstatus"
                        :value="false" />
                      Disable
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders, reportUploadError } from './../../../utils/imageUpload';
export default {
  name: "sliderModalEdit",
  props: ["id", "title", "image", "subtitle", "offer", "link", "titlecolor", "subtitlecolor", "offercolor", "align", "status", "host"],
  data() {
    return {
      Vid: null,
      Vtitle: null,
      Vimage: null,
      Vsubtitle: null,
      Voffer: null,
      Vlink: null,
      Vtitlecolor: null,
      Vsubtitlecolor: null,
      Voffercolor: null,
      Valign: null,
      Vstatus: null,
      EditSliderOptions: {
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 250,
        thumbnailHeight: 250,
        maxFiles: 1,
        params: [],
        maxfilesexceeded: function (file) {
          this.removeAllFiles();
          this.addFile(file);
        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let image = this.options.params[0].image;
          let f = {
            size: '12300',
            name: this.options.params[0].id,
            dataURL: image,
          };
          this.files.push(f);
          this.emit("addedfile", f);
          this.emit("thumbnail", f, f.dataURL);
          this.emit("complete", f);
          this.on("removedfile", function (file) {
            return null;
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
      },
    };
  },
  methods: {
    onSave() {
      var formData =
      {
        id: this.id,
        image: this.Vimage,
        title: this.Vtitle,
        subtitle: this.Vsubtitle,
        offer: this.Voffer,
        link: this.Vlink,
        titlecolor: this.Vtitlecolor,
        subtitlecolor: this.Vsubtitlecolor,
        offercolor: this.Voffercolor,
        align: this.Valign,
        status: this.Vstatus
      }
      this.$emit("formData", formData);
    },
    onFileChange(event) {
      let picture = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(picture);
      reader.onloadend = (e) => {
        this.Vimage = e.target.result;
      };
    },
    showmodal() {
      this.$bvModal.show('Modal' + this.id);
    },
    OnShowModal() {
      this.Vid = this.id;
      // Champs textuels : chaîne vide si le slider ancien ne les contient
      // pas — Firestore refuse d'enregistrer « undefined » et bloquerait
      // alors TOUT l'enregistrement du slider (image, textes, couleurs).
      this.Vtitle = this.title || '';
      this.Vimage = this.image || '';
      this.Vsubtitle = this.subtitle || '';
      this.Voffer = this.offer || '';
      this.Vlink = this.link || '';
      // Couleurs absentes des sliders créés avant cette option : blanc,
      // comme le repli utilisé par la vitrine.
      this.Vtitlecolor = this.titlecolor || '#ffffff';
      this.Vsubtitlecolor = this.subtitlecolor || '#ffffff';
      this.Voffercolor = this.offercolor || '#ffffff';
      this.Valign = this.align || 'p-center';
      // Statut absent ou stocké en texte ("true"/"false") sur les vieux
      // sliders : on ramène un vrai booléen, actif par défaut (la vitrine
      // ne masque un slider que si status vaut false).
      this.Vstatus = (this.status === 'false' || this.status === false) ? false : true;
      this.EditSliderOptions.params.push({
        "id": this.id,
        "image": this.image
      })
    },
    imageResize(base64Str) {
      var img = new Image();
      img.src = base64Str;
      var canvas = document.createElement('canvas');
      var MAX_WIDTH = 500;
      var MAX_HEIGHT = 200;
      var width = img.width;
      var height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      return canvas.toDataURL();
    },
    uploadComplete(file, response) {
      // L'API renvoie directement { url: '/uploads/...' } : l'image est
      // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.Vimage = data.url;
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    fileRemoved() {

    },
    uploadSuccess() {

    },
    clear() {
      this.form = [];
    },
    uploadError(file, message) {
      reportUploadError(this, message);
    },
    sending(file, xhr, formData) {
      // Juste avant l'envoi : indique à l'API le dossier de stockage
      // (l'option dropzone « params » est déjà utilisée pour l'affichage
      // de l'image existante, on passe par cet événement à la place).
      formData.append('folder', 'sites/' + this.host + '/sliders');
    }
  }
}
</script>

<style lang="scss" scoped>
/* Cadre couleur à droite de chaque champ texte : cadre cliquable qui
   ouvre la palette de couleurs du navigateur */
.slider-color-input {
    display: flex;
    align-items: center;

    .form-control {
        flex: 1 1 auto;
        min-width: 0;
    }

    input[type="color"] {
        flex-shrink: 0;
        width: 3.25rem;
        height: 2.38rem;
        margin-left: 0.5rem;
        padding: 0.15rem;
        border: 1px solid #e6e2e6;
        border-radius: 0.25rem;
        background-color: #fff;
        cursor: pointer;
    }
}
</style>